import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import type {
    ForgotPasswordRequest,
    LoginRequest,
    ResetPasswordByCodeRequest,
    ResetPasswordByTokenRequest,
} from '../models/session.model';
import type { WebUsuario } from '../models/usuario.model';
import { environment } from '@env/environment';
import type { ApiResponse } from '@shared/models/api.model';

@Injectable({ providedIn: 'root' })
export class AuthService {
    private readonly http = inject(HttpClient);
    private readonly base = `${environment.apiUrl}/auth`;

    login(body: LoginRequest) {
        return this.http.post<ApiResponse<WebUsuario>>(`${this.base}/login`, body);
    }

    logout() {
        return this.http.post<void>(`${this.base}/logout`, {});
    }

    whoami() {
        return this.http.get<ApiResponse<WebUsuario>>(`${this.base}/me`);
    }

    csrf() {
        return this.http.get<string>(`${this.base}/csrf`);
    }

    forgotPassword(body: ForgotPasswordRequest) {
        return this.http.post<void>(`${this.base}/forgot-password`, body);
    }

    resetPasswordByToken(body: ResetPasswordByTokenRequest) {
        return this.http.post<void>(`${this.base}/reset-password`, body);
    }

    resetPasswordByCode(body: ResetPasswordByCodeRequest) {
        return this.http.post<void>(`${this.base}/reset-password/code`, body);
    }
}
